const ITEM_TYPE = "ITEM";
export enum StatusCartItem {
  TODO = "TODO",
  DONE = "DONE",
}

export default ITEM_TYPE;
